import _font from 'styles/global/_font'

const genericStyles = {
  alertContainer: {
    ..._font.fontFamilyDefault,
    fontSize: '14px',
    marginBottom: '5px',
    maxWidth: '673px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '4px',
    height: '40px',
    padding: '8px 16px',
    gap: '8px',
    alignSelf: 'stretch',
  },
}

export default genericStyles
